// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e63-","field":"styles_field__OkZ3q","fieldCol":"styles_fieldCol__2JKuY","diffCol":"styles_diffCol__3odph","diff":"styles_diff__3Y2ZG"};